import { GenericObject } from "utility/misc";

export default function redirectToGoogleConnectPage(
  _orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/sources/google/connect");
}
